<template>
  <div
    class="nav-bar-content"
    :class="{ 'nav-bar-opacity1': opacity == 1 }"
    :style="{
      height: height + 'px',
      paddingTop: statusBarHeight + 'px',
      backgroundColor: 'rgba(255,255,255,' + opacity + ')'
    }"
  >
    <div class="back" @click="bindBack"><i class="iconfont icon-you"></i></div>
    <div
      class="title"
      :style="{
        opacity
      }"
      >{{ opacity >= 0.2 ? detailData.name : '' }}</div
    >
    <div class="share" @click="bindShare" v-if="showShare"
      ><i class="iconfont icon-fenxiang11"></i
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    detailData: {},
    opacity: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      statusBarHeight: 0,
      height: 0
    }
  },
  computed: {
    showShare() {
      // return [
      //   18390943799, 18008408952, 13207135523, 13290053690, 13875806501,
      //   18173131542, 18173131436
      // ].includes(this.$store.state.user.user.phone * 1)
      return true
    }
  },
  watch: {
    opacity() {}
  },
  created() {
    this.getBottomContentHeight()
  },
  methods: {
    getButtonColor(opacity) {
      return 'rgba(0,0,0,' + (opacity <= 0.5 ? 0.5 : 0.5 - 0.5 * opacity) + ')'
    },
    bindBack() {
      this.$http.appBack()
    },
    bindShare() {
      this.$emit('share')
    },
    async getBottomContentHeight() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.statusBarHeight = res.statusBarHeight
          this.height = this.statusBarHeight + res.toolsBarHeight
        }
      } else {
        this.statusBarHeight = 40
        this.height = this.statusBarHeight + 28
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-bar-content {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 66;
  color: #000000;
  .title {
    text-align: center;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 600;
  }
  .back,
  .share {
    font-weight: bold;
    position: absolute;
    z-index: 5;
  }
  .back {
    left: 22px;
  }
  .share {
    right: 20px;
  }
  .icon-you {
    display: block;
    font-size: 22px;
    transform: rotate(180deg);
  }
  .icon-fenxiang11 {
    font-weight: normal;
    font-size: 20px;
  }
}
.nav-bar-opacity1 {
  .share,
  .back {
  }
}
</style>
